import React, { useState } from "react";
import axios from "axios";
import { TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import { baseUrl } from "../utils/baseUrl";
import { useGlobalAuthContext } from "../context/AuthContext";
import StandardDialog from "./StandardDialog";
import { getMFPrimaryButtonSx } from "../utils/dialogStyles";
import { getAuthGlassFieldSx } from "./Auth/authGlassStyles";

const NewFolderDialog = ({
  isOpen,
  onClose,
  setReloadFiles,
  parent,
}) => {
  const theme = useTheme();
  const [folderName, setFolderName] = React.useState("");
  const [folderError, setFolderError] = useState(null);
  const [loader, setLoader] = useState(false);

  const { currentUserSessionStorage } = useGlobalAuthContext();

  const getHeaders = () => ({
    Authorization: `Bearer ${currentUserSessionStorage}`,
  });

  const handleSend = async () => {
    if (folderName == "") {
      setFolderError("Name your folder");
      return;
    }
    setLoader(true);

    try {
      const path = `/savedLayout/add`;

      const response = await axios.post(
        `${baseUrl}${path}`,
        { name: folderName, parent: parent},
        { headers: getHeaders() }
      );

      setLoader(false);

      if (response.status === 201 || response.status === 200) {
        onClose();
        setFolderName("");
        setReloadFiles((prev) => !prev);
     
      }
    } catch (error) {
      setLoader(false);

   
    }
  };

  return (
    <StandardDialog
      open={isOpen}
      onClose={onClose}
      title="Add new folder"
      footerLayout="stretch"
      PaperProps={{
        sx: {
          overflow: "visible",
          borderRadius: "44px",
        },
      }}
      footer={
        <LoadingButton
          loading={loader}
          onClick={handleSend}
          variant="contained"
          fullWidth
          sx={getMFPrimaryButtonSx(theme)}
        >
          Create folder
        </LoadingButton>
      }
    >
      <TextField
        size="medium"
        variant="outlined"
        placeholder="Untitled"
        error={!!folderError}
        helperText={folderError}
        autoFocus
        onKeyDown={(event) => {
          if (event.key === "Enter") handleSend();
        }}
        onChange={(e) => {
          setFolderName(e.target.value);
          if (folderError) setFolderError(null);
        }}
        fullWidth
        sx={{ mt: 0.25, ...getAuthGlassFieldSx(theme) }}
      />
    </StandardDialog>
  );
};

export default NewFolderDialog;
